import { createAction } from '@reduxjs/toolkit';

export const printHTML = createAction<string>('PRINT_HTML');
export const silentPrintHTML = createAction<string>('SILENT_PRINT_HTML');
export const printHTMLLoading = createAction<boolean>('PRINT_HTML_LOADING');
export const setPrinterModalState = createAction<{
  isOpenSetPrinterModal?: boolean;
  printSessionExists?: boolean;
}>('SET_PRINTER_MODAL_STATE');
